import {Button} from 'shells/button/button';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Modal} from 'shells/modal/modal';
import {Body} from 'shells/typography/body';

import type {GetMoneyPage_maUrl as MoneyPage} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {TRIGGER_FAST_NOTIFICATION_POLL_EVENT} from '../../navigation/navbar/notification-bell-button';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    automation: MoneyPage;
};

export function TestPageModal(props: Props) {
    const {user} = useGetSessionUser();

    const handleTestPage = () => {
        if (!user) return;
        // Open in new tab with query params for testing
        // nstest=true triggers the test flow
        // nsuser=<userApiId> identifies who to notify
        const testParams = new URLSearchParams({
            nstestautomation: props.automation.id,
            nsuser: user.id,
        });
        window.open(`${props.automation.url.fullyQualifiedUrl}?${testParams.toString()}`);

        // normal notification polling is 5 minute interval, we want this to show up faster since user will be waiting
        window.dispatchEvent(new CustomEvent(TRIGGER_FAST_NOTIFICATION_POLL_EVENT));

        props.onClose();
    };

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            headerText='Test out your marketing automation'
            isCentered={true}
            canClickOutsideToClose={true}
            fitHeight={true}
            maxWidth={470}
            closeButton={false}
        >
            <Stack spacing={24} alignItems='center' isFullWidth={true}>
                <Body color='light'>
                    Let’s test out your automation! <br />
                    Click below to simulate a “real” visitor landing on this page. You’ll receive an
                    in-app notification if your setup is working.
                </Body>
                <Illustration src='page-visit-notification' width={350} />
                <div className='flex justify-sb gap-12 pb-32 full-width'>
                    <Button variant='text-secondary' size='big' onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button variant='save' size='big' onClick={handleTestPage}>
                        Let’s do it!
                    </Button>
                </div>
            </Stack>
        </Modal>
    );
}
